import { Buyer } from '@40seas/entities/buyers';
import { QueryDtoOf } from '@40seas/entities/common';
import { Checkout } from './checkout.entity';

export class QueryCheckoutDto extends QueryDtoOf(Checkout, [Buyer]) {}
